<template>
  <div>
    <div class="d-flex justify-content-between mb-3 pb-1">
      <DateRange :update="dateRange" :startDate="filter.startDate" :endDate="filter.endDate"/>
      <div>
        <b-button variant="primary" size="sm" class="ml-3" @click="goToNewCoverSheetPage">
          <BIconPlus />{{ 'Neue Zusammenfassung' | i18n }}
        </b-button>
      </div>
    </div>
    <Table
      :update="getPage"
      :columns="columns"
      :rows="rows"
      :filter="filter"
      :update-filter="updateFilter"
      :loading-instance="loadingInstance"
      :set-loading-instance="setLoadingInstance"
      class="overflow-auto pr-1"
      table-name="plantInputTable"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { AuthMixin } from '../../../../mixins';
import { BIconPlus } from 'bootstrap-vue';
import api from '../../../api';
import DateRange from '../../common/date-range';
import Table from '../../common/table';
import moment from 'moment';

export default {
  title: 'Deckblatt',
  components: { DateRange, Table, BIconPlus },
  mixins: [AuthMixin],
  data() {
    return {
      deckblatt: api.deckblatt,
      loadingInstance: null,
      rows: [],
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
        startDate: moment().startOf('month').add(3, 'hour'),
        endDate: moment(),
      },
      isPdfDataLoading: false,
      columns: [
        {
          field: 'date',
          title: this.$translate('Date'),
          key: '9',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }, h) => {
            return <div class={`status-cell`}>{moment(row.date).format('DD.MM.YYYY')}</div>;
          },
        },
        {
          field: 'quantityOfDeliveredWaste',
          title: this.$translate('Menge der abgelieferten Abfälle'),
          key: '6',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }, h) => {
            const quantityOfDeliveredWaste = parseFloat(row.quantityOfDeliveredWaste);
            return <div class={`status-cell`}>{quantityOfDeliveredWaste.toLocaleString('de-De')}</div>;
          },
        },
        {
          field: 'quantityOfDeliveredResidues',
          title: this.$translate('Menge der abgelieferten Reststoffe'),
          key: '3',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }, h) => {
            const quantityOfDeliveredResidues = parseFloat(row.quantityOfDeliveredResidues);
            return <div class={`status-cell`}>{quantityOfDeliveredResidues.toLocaleString('de-De')}</div>;
          },
        },
        {
          field: 'groundskeeper',
          title: this.$translate('Platzwart'),
          key: '53',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          width: 110,
          renderBodyCell: (data) => {
            return (
              <div class="action-block">
                <div class="details-action ewq" on-click={async () => await this.downloadPdf(data.row.id)}>
                  PDF
                </div>
              </div>
            );
          },
        },
      ],
    };
  },
  methods: {
    goToNewCoverSheetPage() {
      this.$router.push({ name: 'new-deckblatt' });
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery, startDate, endDate } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (startDate) {
          ctx.startDate = moment(startDate).format('yyyy-MM-DD');
        }
        if (endDate) {
          ctx.endDate = moment(endDate).format('yyyy-MM-DD');
        }
        const response = await this.deckblatt.get(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();

        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async downloadPdf(id) {
      try {
        const baseUrl = axios.defaults.baseURL;
        const auth = this.authStorageService.getAuth();
        const token = auth.access_token;

        fetch(`${baseUrl}/api/v1/gmva/deckblatt/${id}/pdf`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${moment().format('yyyy-MM-DD')}_Deckblatt.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.showNotification({ type: 'success', message: this.$translate('file_has_been_downloaded_successful') });
          })
          .catch((err) => {
            console.log('error', err);
          });
      } catch (error) {
        console.log('error', error);
      }
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    dateRange(d) {
      this.filter.startDate = d.startDate;
      this.filter.endDate = d.endDate;
      this.getPage();
    },
  },
};
</script>

<style lang="scss">
.ewq {
  color: white;
  background: linear-gradient(#2260ff, #2260ff);
  border-radius: 4px;
  cursor: pointer;
  width: 40px;
}
</style>
